import {z} from '@hono/zod-openapi';

export const advertisingTaxonomyRefreshRunSchema = z
  .object({
    id: z.string().uuid(),
    platformCode: z.string().min(1),
    status: z.enum(['queued', 'running', 'completed', 'failed']),
    phase: z.enum([
      'queued',
      'fetching',
      'model-compatibilities',
      'building-taxonomy',
      'persisting-taxonomy',
      'staging',
      'scheduling-coverage',
      'completed',
      'failed',
    ]),
    progressPercent: z.number().int().min(0).max(100),
    rowCount: z.number().int().nonnegative().nullable(),
    refreshBatchId: z.string().nullable(),
    attempt: z.number().int().nonnegative(),
    failureReason: z.string().nullable(),
    requestedBy: z.string(),
    startedAt: z.string().datetime().nullable(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
  })
  .openapi('AdvertisingTaxonomyRefreshRun');

export type AdvertisingTaxonomyRefreshRun = z.infer<typeof advertisingTaxonomyRefreshRunSchema>;
